module.exports = __webpack_public_path__ + "img/WP_Snake_Greatsword.ee779439.png";